module.exports = __webpack_public_path__ + "static/media/a1-logo.a891884e.png";